import { getAPI, postAPI } from "./Networking";
import { PartnerAnalyticsChartData } from "../models/Dashboard/PartnerDashboard/PartnerAnalytics";
import { PartnerAnalyticsAPIFilters } from "../models/Dashboard/PartnerDashboard/PartnerAnalyticsFilters";
import { GetShipmentsParams } from "../stores/ShipmentStore";
import { PaginatedAPIResponse } from "../models/NetworkResponse";
import { Shipments } from "../models/Shipments";

export default class PartnerAnalyticsDashboardAPI {
  getShipmentsChartData = async (
    filters: PartnerAnalyticsAPIFilters
  ): Promise<PartnerAnalyticsChartData> => {
    try {
      const queryParams = new URLSearchParams();
      if (filters.start_date)
        queryParams.append("start_date", filters.start_date);

      if (filters.end_date) queryParams.append("end_date", filters.end_date);

      if (filters.partner_id && filters.partner_id.length > 0) {
        queryParams.append(
          "partner_id",
          filters.partner_id.map((item) => item.id).join(",")
        );
      }

      const response = await getAPI(
        `/v5/partner-analytics?${queryParams.toString()}`
      );
      return response.result;
    } catch (error) {
      throw error;
    }
  };

  getShipments = async (params: GetShipmentsParams): Promise<any> => {
    try {
      const queryParams = new URLSearchParams();
      if (params.page) queryParams.append("page_no", params.page.toString());
      if (params.limit) queryParams.append("limit", params.limit.toString());
      if (params.sortBy) queryParams.append("sort_by", params.sortBy);
      if (params.sortType) queryParams.append("sort_type", params.sortType);
      if (params.search) queryParams.append("search_text", params.search);

      if (
        params.inventory_type &&
        (params.inventory_type === "1" || params.inventory_type === "2")
      ) {
        queryParams.append("inventory_type", params.inventory_type);
      }

      if (params.shipment_type && params.shipment_type.length > 0) {
        queryParams.append("shipment_type", params.shipment_type.join(","));
      }
      if (params.status && params.status.length > 0) {
        queryParams.append("status", params.status.join(","));
      }
      if (params.delivery_partner_id && params.delivery_partner_id.length > 0) {
        queryParams.append(
          "delivery_partner_id",
          params.delivery_partner_id.join(",")
        );
      }

      if (params.order_id && params.order_id.length > 0) {
        queryParams.append("order_id", params.order_id.join(","));
      }

      if (params.c_id && params.c_id.length > 0) {
        queryParams.append("c_id", params.c_id[0].id);
      }

      const DimensionsFilter = [
        { id: 1, value: "dimensions" },
        { id: 2, value: "weight" },
        { id: 3, value: "shipping_cost" },
        { id: 4, value: "awb" },
        { id: 5, value: "packs" },
      ];

      if (params.dimensions && params.dimensions.length > 0) {
        DimensionsFilter.forEach((filter) => {
          if (params.dimensions?.includes(filter.id)) {
            queryParams.append(filter.value, "true");
          }
        });
      }
      const response = await postAPI(
        `/v5/partner-analytics/shipments?${queryParams.toString()}`,
        { download_csv: false, emails: params.emails }
      );
      return response.result as PaginatedAPIResponse<Shipments>;
    } catch (error) {
      throw error;
    }
  };
}
